import { render, staticRenderFns } from "./TransactionMomo.vue?vue&type=template&id=63b2a926&scoped=true"
import script from "./TransactionMomo.vue?vue&type=script&lang=js"
export * from "./TransactionMomo.vue?vue&type=script&lang=js"
import style0 from "./TransactionMomo.vue?vue&type=style&index=0&id=63b2a926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b2a926",
  null
  
)

export default component.exports